// de strings for messages/studioOptions.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const studioOptions: Dict = {
  "studioOptions.pitch.title": "Tonhöhe",
  "studioOptions.pitch.hint":
    "In Halbtönen. Von einer Männer- zu einer Frauenstimme? Probier +12.",
  // aria-label with stepper.lower: "Tonhöhe für Drake senken"
  "studioOptions.pitch.label": "Tonhöhe für {name}",
  "studioOptions.pitch.maleToFemale": "Männlich → weiblich",
  "studioOptions.pitch.femaleToMale": "Weiblich → männlich",
  "studioOptions.pitch.original": "Original",
  "studioOptions.stepper.lower": "{label} senken",
  "studioOptions.stepper.raise": "{label} erhöhen",
  "studioOptions.effect.title": "Effekt",
  "studioOptions.effect.hint":
    "Immer nur einer. Tipp nochmal, um ihn zu entfernen.",
  "studioOptions.effect.none": "Keiner",
  "studioOptions.effect.onVocals": "Auf dem Gesang",
  "studioOptions.effect.onSong": "Auf dem ganzen Song",
  "studioOptions.autotune.title": "Autotune",
  "studioOptions.autotune.switch": "Gesang auf die Tonart ziehen",
  "studioOptions.autotune.hint":
    "Vom leichten Feinschliff bis zum deutlichen Roboter-Sound.",
  "studioOptions.autotune.light": "Leicht",
  "studioOptions.autotune.medium": "Mittel",
  "studioOptions.autotune.strong": "Stark",
  "studioOptions.mix.title": "Mix",
  "studioOptions.mix.vocalVolume": "Gesangslautstärke",
  "studioOptions.mix.vocalVolumeHint":
    "Lauter oder leiser als die Musik, in dB.",
  "studioOptions.mix.vocalVolumeLabel": "Gesangslautstärke",
  "studioOptions.mix.backing": "Backing Vocals trennen",
  "studioOptions.mix.backingHint":
    "Saubereres Ergebnis, wenn der Song Harmonien oder Ad-libs hat.",
  "studioOptions.mix.vocalsOnly": "Mein Audio ist nur Gesang",
  "studioOptions.mix.vocalsOnlyHint":
    "Überspringt das Trennen von Gesang und Musik.",
  "studioOptions.name.title": "Name des Covers",
  "studioOptions.name.placeholder": "Optional",

  "studioOptions.summary.pitch": "Tonhöhe {values}",
  "studioOptions.summary.autotune": "Autotune",
  "studioOptions.summary.vocals": "Gesang {value}",
  "studioOptions.summary.backing": "Backing Vocals getrennt",
  "studioOptions.summary.vocalsOnly": "Nur Gesang als Input",
  "studioOptions.summary.default": "Originale Tonhöhe, keine Effekte",

  "studioOptions.video.previewAria": "Vorschau des Marble Run",
  "studioOptions.video.headline":
    "Deine Stimmen treten gegeneinander an. Wer führt, singt.",
  "studioOptions.video.body":
    "Führungswechsel werden zu Stimmwechseln, mit dem Songtext im Bild. Bereit zum Posten auf TikTok und Reels.",
  "studioOptions.video.crown": "Die Krone zeigt, wer singt",
  "studioOptions.video.pickLook": "Wähle einen Look",
  "studioOptions.video.customise": "Anpassen",
  "studioOptions.video.surprise": "Überrasch mich",
  "studioOptions.video.marbles": "Murmeln und Bahn",
  "studioOptions.video.sky": "Himmel",
  "studioOptions.video.font": "Schrift für den Songtext",
  "studioOptions.video.stars": "Sterne am Himmel",
  "studioOptions.theme.midnight": "Mitternacht",
  "studioOptions.theme.neon": "Neon",
  "studioOptions.theme.ocean": "Ozean",
  "studioOptions.theme.royal": "Royal",
  "studioOptions.theme.lava": "Lava",
  "studioOptions.theme.gold": "Gold",

  "studioOptions.upload.empty":
    "Diese Datei ist leer. Bitte wähle die Songdatei erneut aus.",
  "studioOptions.upload.tooBig":
    "Die Datei ist größer als 75 MB! Bitte lade eine kleinere Datei hoch.",
  "studioOptions.upload.tooLong":
    "Das Audio ist länger als 6 Minuten! Bitte lade eine kürzere Datei hoch.",
  "studioOptions.upload.invalid": "Bitte lade eine gültige Audiodatei hoch",
  "studioOptions.upload.unexpected": "Ein unerwarteter Fehler ist aufgetreten.",
  "studioOptions.upload.uploading": "Wird hochgeladen...",
  "studioOptions.upload.coverAlt": "Cover",
  "studioOptions.upload.dropIt": "Loslassen",
  "studioOptions.upload.dropHere": "Zieh dein Audio hierher",
  "studioOptions.upload.browse": "Dateien durchsuchen",
  "studioOptions.upload.formats": "MP3, WAV oder M4A · bis zu 6 Minuten",
  "studioOptions.upload.dropOrBrowse":
    "Zieh eine Audiodatei hierher oder klick zum Durchsuchen",
  "studioOptions.upload.limits": "Max. 75 MB, 6 Min. • MP3, WAV, M4A",

  "studioOptions.mic.denied":
    "Erlaube den Mikrofonzugriff in deinem Browser, um aufzunehmen.",
  "studioOptions.mic.notFound": "Kein Mikrofon zum Aufnehmen gefunden.",
  "studioOptions.mic.prepareFailed":
    "Der Upload-Speicherort konnte nicht vorbereitet werden.",
  "studioOptions.mic.fileFailed": "Die Datei konnte nicht hochgeladen werden.",
  "studioOptions.mic.uploadFailed":
    "Upload der Mikrofonaufnahme fehlgeschlagen.",
  "studioOptions.mic.previewFailed":
    "Die Audiovorschau konnte nicht abgespielt werden.",
  "studioOptions.mic.start": "Aufnahme starten",
  "studioOptions.mic.stop": "Aufnahme beenden",
  "studioOptions.mic.tapRecord": "Zum Aufnehmen tippen",
  "studioOptions.mic.tapStop": "Zum Beenden tippen",
  "studioOptions.mic.clickRecord": "Zum Aufnehmen klicken",
  "studioOptions.mic.processing": "Wird verarbeitet...",
  "studioOptions.mic.playPreview": "Vorschau abspielen",
  "studioOptions.mic.pausePreview": "Vorschau pausieren",
  "studioOptions.mic.yourRecording": "Deine Aufnahme",
  "studioOptions.mic.use": "Diese Aufnahme verwenden",
  "studioOptions.mic.again": "Neu aufnehmen",
  "studioOptions.mic.continue": "Weiter",
};

export default studioOptions;
